// project import
import applications from './applications';
import team from './managements';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [applications, team]
};

export default menuItems;

export const getMenuItems = (isAdmin: boolean): { items: NavItemType[] } => {
  const items = [applications];

  if (isAdmin) {
    items.push(team);
  }

  return { items };
};
